import React, {useState} from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import api from "../../../api/api";
import Images from "../../../media/images";

const CreateEmployee = () => {
  const { register, handleSubmit } = useForm();
  // const [image, setImage] = useState("");

  const handleSub =  (data) => {

   
    const formData = new FormData();

    formData.append("name", data.name)
    formData.append("designation", data.designation)
    formData.append("contact_number", data.contact_number)
    // formData.append("image", image)
    formData.append("image", data.image[0])
    formData.append("email", data.email)
    formData.append("address", data.address)
    formData.append("info", data.info)

    api.post("info/employee-details/", formData)
    .then(response=> {
        toast.success("Data Registered Successfully")
    }).catch(error=> {
        toast.error("Something went wrong")
    })
  };

  // const handleChange = async (e) => {

  //   let reader = new FileReader();
  //   let baseURL = "";

  //   reader.readAsDataURL(e.target.files[0]);
  //   // on reader load somthing...
  //   return new Promise((resolve) => {
  //     reader.onload = () => {

  //       baseURL = reader.result;
  //       setImage(baseURL)
  //       resolve(baseURL);
  //     };
  //   });
  // };

  return (
    <div>
      <div className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
        Create Employees
      </div>
      <div className="">
        <img src={Images.title_border} alt="" className="mx-auto mt-4" />
      </div>

      <form onSubmit={handleSubmit(handleSub)}>
        <div className="grid md:grid-cols-2">
          <div className="border-primary-blue flex items-center gap-2 border-2 p-2">
            <label htmlFor="" className="text-primary-red">
              Name
            </label>
            <input
              type="text"
              name="name"
              className="flex-grow py-2 px-2 outline-none"
              id=""
              placeholder="Name"
              {...register("name", { required: false })}
            />
          </div>
          <div className="border-primary-blue flex items-center gap-2 border-2 border-t-0 p-2 md:!border-t-2 md:border-l-0">
            <label htmlFor="" className="text-primary-red">
              Designation
            </label>
            <input
              type="text"
              name="designation"
              className="flex-grow py-2 px-2 outline-none"
              id=""
              placeholder="Designation"
              {...register("designation", { required: false })}
            />
          </div>
          <div className="border-primary-blue flex items-center gap-2 border-2 border-t-0 p-2">
            <label htmlFor="" className="text-primary-red">
              Contact Number
            </label>
            <input
              type="text"
              name=""
              className="flex-grow py-2 px-2 outline-none"
              placeholder="Contact Number"
              {...register("contact_number", { required: false })}
            />
          </div>
          <div className="border-primary-blue flex items-center gap-2 border-2 border-t-0 p-2 md:border-l-0">
            <label htmlFor="" className="text-primary-red">
              Image:
            </label>
            <input
              type="file"
              // name=""
              className="text-primary-blue file:bg-primary-red ml-3 w-full outline-none file:rounded-lg file:text-white"
              id=""
              {...register("image", { required: false })}
              // onChange={(e) => handleChange(e)}
            />
          </div>
          <div className="border-primary-blue flex items-center gap-2 border-2 border-t-0 p-2 md:border-l-0">
            <label htmlFor="" className="text-primary-red">
              Email:
            </label>
            <input
              type="text"
              name="email"
              className="text-primary-blue file:bg-primary-red ml-3 w-full outline-none file:rounded-lg file:text-white"
              id=""
              {...register("email", { required: false })}
            />
          </div>
          <div className="border-primary-blue flex items-center gap-2 border-2 border-t-0 p-2 md:border-l-0">
            <label htmlFor="" className="text-primary-red">
              Address:
            </label>
            <input
              type="text"
              name="address"
              className="text-primary-blue file:bg-primary-red ml-3 w-full outline-none file:rounded-lg file:text-white"
              id=""
              {...register("address", { required: false })}
            />
          </div>
          <div className="border-primary-blue border-2 border-t-0 p-2">
            <p className="text-primary-red font-bold">Description</p>
            <textarea
              name="info"
              className="w-full border border-gray-700"
              id=""
              rows="{10}"
              {...register("info")}
            />
          </div>
        </div>

        <div className="flex items-center justify-center">
          <button
            className="bg-primary-blue mt-3 text-center  gap-2 rounded-md px-5 py-3 font-bold text-white"
            type="submit"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateEmployee;
